'use strict'
import { default as Component } from '../component.js'
import month from '../constants/month.js'

class SelectMonth extends Component
{
	init()
	{
		if (Object.keys(App.Store.model('month')).length == 0)
			App.Store.sync(month)
	}
}

export default SelectMonth
